export default "__VITE_ASSET__D7AEA7gB__"